import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectActiveThemedEventInfo, selectEventInfoByTypeId, } from "../../../../selectors/selectEventInfo";
import { selectQuestEndTime, selectQuestInfoTasks } from "../../../../selectors/selectQuestInfo";
import { actionModalClose, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionQuestFinish } from "./actionQuests";
import { QuestItemButton } from "./QuestItemButton";
import { QuestItemDescription } from "./QuestItemDescription";
import { QuestItemRewards } from "./QuestItemRewards";
import { QuestItemTask } from "./QuestItemTask";
var _QuestItem = function (_a) {
    var quest = _a.quest, completed = _a.completed, themedEventInfo = _a.themedEventInfo, onThemedEventIconClick = _a.onThemedEventIconClick, eventInfo = _a.eventInfo, getQuestEndTime = _a.getQuestEndTime, onFinish = _a.onFinish, questInfoTaskMap = _a.questInfoTaskMap;
    var _b = useState(false), buttonDisable = _b[0], setButtonDisable = _b[1];
    useEffect(function () {
        setButtonDisable(false);
    }, [quest]);
    var onClick = function (questId) {
        onFinish(questId);
        setButtonDisable(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "quest-item__top " + (completed ? "completed" : "") },
            React.createElement(QuestItemDescription, { eventInfo: eventInfo, getQuestEndTime: getQuestEndTime, isCompleted: completed, onThemedEventIconClick: onThemedEventIconClick, quest: quest, themedEventInfo: themedEventInfo }),
            React.createElement(QuestItemRewards, { quest: quest, isCompleted: completed })),
        React.createElement("div", { className: "quest-item__bottom" }, completed ? (React.createElement(QuestItemButton, { quest: quest, onClick: onClick, isCollectBtnDisabled: buttonDisable })) : (React.createElement(QuestItemTask, { questInfoTaskMap: questInfoTaskMap, quest: quest })))));
};
var mapState = function (state, ownProps) {
    var eventInfo = ownProps.quest.eventId
        ? selectEventInfoByTypeId(state, ownProps.quest.eventId)
        : undefined;
    return {
        eventInfo: eventInfo,
        getQuestEndTime: function (questId) { return selectQuestEndTime(state, questId); },
        questInfoTaskMap: selectQuestInfoTasks(state),
        themedEventInfo: selectActiveThemedEventInfo(state),
    };
};
var mapDispatch = function (dispatch) { return ({
    onFinish: function (questId) { return dispatch(actionQuestFinish(questId)); },
    onThemedEventIconClick: function () {
        dispatch(actionModalClose(IdModal.Quests));
        dispatch(actionModalOpen(IdModal.ThemedEvent));
    },
}); };
export var QuestItem = connect(mapState, mapDispatch)(_QuestItem);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestItem.tsx
// module id = 2659
// module chunks = 3